/**
 * [用户配送费调控弹窗]
 * @author: Fu Xiaochun
 * @date: 2021-08-04 
 */

import React, { useState, useEffect } from 'react';
import styles from './UserControlFee.module.scss';
import PropTypes from 'prop-types';
import { message, Modal, Select, Checkbox, DatePicker, Popover, Radio, Input   } from 'antd';
import http from '@/assets/api/http';
import { CaretDownOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { getEnum } from '@/apis/common/index';
import { regFenToYuan } from '@/util/money';


const { Option } = Select;
const { RangePicker } = DatePicker;

function UserControlFee(props){

    const logId = props.logId;
    const tid = props.data.templateId;
    const dateFormat = 'YYYY-MM-DD HH:mm';
    
    const [logDetail, setLogDetail] = useState({});
    const [reasonOptions, setReasonOptions] = useState([]);
    const [reason, setReason] = useState();
    const [cityObj, setCityObj] = useState({});
    const [cityList, setCityList] = useState([]);
    const [curCityId, setCurCityId] = useState(0);
    const [areaPopoverTop, setAreaPopoverTop] = useState();
    const [areaPopoverArrowLeft, setAreaPopoverArrowLeft] = useState();
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [controlMethod, setControlMethod] = useState('PERCENT');
    const [percent, setPercent] = useState('');
    const [fixedVal, setFixedVal] = useState('');

    useEffect(()=>{
        getReasonEnum();
        if(logId){
            getControlDetail();
        }else{
            getShippingFeeDetai();
        }
        document.addEventListener('click', resetAreaList);
        return ()=>{
            document.removeEventListener('click', resetAreaList);
        };
    }, []);

    useEffect(()=>{
        let list = [];
        let cityList = Object.values(cityObj);
        cityList.forEach(c=>{
            if(c.checked > 0){
                let temp = {
                    cityId: c.cityId,
                    cityName: c.cityName,
                    provinceId: c.provinceId,
                    areaList: []
                };
                Object.values(c.areaList).forEach(x=>{
                    if(x.checked){
                        temp.areaList.push({
                            areaId: x.areaId,
                            areaName: x. areaName
                        });
                    }
                });

                list.push(temp);
            }
        });
        setCityList(list);
    }, [cityObj]);

    useEffect(()=>{
        if(logDetail.templateId){
            initDetailData();
            getShippingFeeDetai();
        }
    }, [logDetail]);

    const initDetailData = ()=>{
        setReason({value: logDetail.reason});
        setStartTime(logDetail.gmtStart);
        setEndTime(logDetail.gmtEnd);
        setControlMethod(logDetail.type);

        if(logDetail.type == 'PERCENT'){
            setPercent(logDetail.amount / 100);
        }else{
            setFixedVal(regFenToYuan(logDetail.amount));
        }
    };

    const resetAreaList = ()=>{
        setCurCityId(0);
    };
    
    const getReasonEnum = () => {
        getEnum({enumName: 'DeliveryRegulateReasonEnum'}).then(res=>{
            setReasonOptions(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const getControlDetail = ()=>{
        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.regulateDetail', {id: logId}, 'post').then(res=>{
            setLogDetail(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const getShippingFeeDetai = ()=>{
        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.detail', {id: tid}, 'post').then(res=>{
            initCityObj(res.result.cityInfo.city);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const initCityObj = (list)=>{
        let logCitys = [];
        let temp = {};

        list.forEach(city=>{
            temp[city.cityId] = {
                provinceId: city.provinceId,
                cityId: city.cityId,
                cityName: city.cityName,
                checked: 0,
                areaList: {}
            };
            city.areaList.forEach(x=>{
                temp[city.cityId].areaList[x.areaId] = {
                    areaId: x.areaId,
                    areaName: x.areaName,
                    checked: 0
                };
            });
        });
        
        if(logDetail.cityList){
            logCitys = logDetail.cityList;

            logCitys.forEach((city)=>{
                let areaList = temp[city.cityId].areaList || {};
                let xLen = Object.values(areaList).length;
                if(city.areaList.length == xLen){
                    temp[city.cityId].checked = 1;
                }
                if(city.areaList.length > 0 && city.areaList.length < xLen){
                    temp[city.cityId].checked = 2;
                }
                city.areaList.forEach(x=>{
                    if(temp[city.cityId].areaList[x.areaId]){
                        temp[city.cityId].areaList[x.areaId].checked = 1;
                    }
                });
            });
        }

        setCityObj(temp);
    };

    const reasonChange = (val)=>{
        setReason(val);
    };

    const onControlMethodChange = (e)=>{
        let val = e.target.value;
        setControlMethod(val);
        if(val == 'PERCENT'){
            setPercent('');
        }else{
            setFixedVal('');
        }
    };

    const onPercentChange = (e)=>{
        let val = e.target.value.trim();
        let reg = /^\d+\.?\d{0,2}$/;
        
        if(val != '' && !reg.test(val)){
            val = percent;
        }
        if(val < 0){
            val = 0;
        }
        if(val > 200){
            val = 200;
        }
        setPercent(val);
    };

    const onFixedValChange = (e)=>{
        let val = e.target.value.trim();
        let reg = /^\d+\.?\d{0,2}$/;
        
        if(val != '' && !reg.test(val)){
            val = fixedVal;
        }
        if(val < 0){
            val = 0;
        }
        if(val > 100){
            val = 100;
        }
        setFixedVal(val);
    };

    const onControlTimeChange = (date, dateStr)=>{
        let startVal = dateStr[0];
        let curtime = Date.now();
        let _starttime = new Date(dateStr[0].replace('-','/')).getTime();

        if(_starttime <= curtime){
            startVal = moment(curtime).format('YYYY-MM-DD HH:mm');
        }
        
        setStartTime(startVal);
        setEndTime(dateStr[1]);
    };
    
    const validate = ()=>{
        if(!reason){
            message.error('请选择调控原因');
            return false;
        }
        if(!cityList.length){
            message.error('请选择调控地域');
            return false;
        }
        if(!startTime && !endTime){
            message.error('请选择调控时间');
            return false;
        }
        if(!startTime){
            message.error('请选择调控开始时间');
            return false;
        }
        if(!endTime){
            message.error('请选择调控结束时间');
            return false;
        }
        if(controlMethod == 'PERCENT' && percent == ''){
            message.error('请填写调控比例');
            return false;
        }
        if(controlMethod == 'AMOUNT' && fixedVal == ''){
            message.error('请填写调控金额');
            return false;
        }
        return true;
    };

    const onOk = ()=>{
        if(!validate()){
            return false;
        }

        let formData = {
            templateId: tid,
            templateType: 'USER',
            reason: reason.value,
            gmtStart: moment(startTime).format('YYYY-MM-DD HH:mm:00'),
            gmtEnd: moment(endTime).format('YYYY-MM-DD HH:mm:00'),
            type: controlMethod,
            amount: controlMethod == 'PERCENT' ? percent : fixedVal,
            cityList: cityList,
        };

        if(logId){
            // 编辑
            formData.id = logId;
            let url = '/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.updateDeliveryFeeRegulate';
            http(url, formData, 'post').then(res=>{
                message.success('修改成功！');
                props.onCancel();
            }).catch(err=>{
                message.error(err.message);
            });
        }else{
            // 新建
            http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.addDeliveryFeeRegulate', formData, 'post').then(res=>{
                message.success('创建成功！');
                props.onCancel();
            }).catch(err=>{
                message.error(err.message);
            });
        }
    };

    const makeControlTime = (startTime, endTime)=>{
        if(!startTime || !endTime){
            return [];
        }
        return [moment(startTime, dateFormat), moment(endTime, dateFormat)];
    };

    const onCityClick = (e, cityId)=>{
        e.stopPropagation();
        let target = e.currentTarget;
        
        setCurCityId(cityId);
        setAreaPopoverTop(target.offsetTop + 28);
        setAreaPopoverArrowLeft(target.offsetLeft - 80 + target.offsetWidth / 2);
    };

    const selectCity = (e, cItem)=>{
        e.stopPropagation();
        let checked = e.target.checked;
        let newCityObj = {...cityObj};
        let countyData = newCityObj[cItem.cityId].areaList;

        newCityObj[cItem.cityId].checked = checked ? 1 : 0;

        for(let k in countyData){
            countyData[k].checked = checked ? 1 : 0;
        }

        setCityObj(newCityObj);
    };

    const selectCounty = (e, xItem)=>{
        let checked = e.target.checked;
        let newCityObj = {...cityObj};

        newCityObj[curCityId].areaList[xItem.areaId].checked = checked;
        
        let countyList = Object.values(newCityObj[curCityId].areaList);
        let countyLen = countyList.length;
        let checkedCount = 0;
        countyList.forEach(v=>{
            if(v.checked){
                checkedCount += 1;
            }
        });

        if(checkedCount == 0){
            newCityObj[curCityId].checked = 0;
        }else if(checkedCount == countyLen){
            newCityObj[curCityId].checked = 1;
        }else{
            newCityObj[curCityId].checked = 2;
        }

        setCityObj(newCityObj);
    };

    // 区县列表
    const renderCounty = () => {
        if(curCityId == 0){
            return null;
        }
        let countyList = Object.values(cityObj[curCityId].areaList);
        if(countyList.length == 0){
            return null;
        }
        return (
            <div className={styles.areaPopover} style={{top: areaPopoverTop}} onClick={e=>{e.stopPropagation();}}>
                <div className={styles.areaPopoverArrow} style={{left: areaPopoverArrowLeft}}></div>
                <div className={styles.popBox}>
                    {countyList.map(xItem=>{
                        return (
                            <div key={xItem.areaId} className={styles.popItem} style={{color: xItem.canChoose==0 ? '#999': null}}>
                                <label>
                                    <Checkbox
                                        style={{ marginRight: 5}}
                                        id={xItem.id}
                                        checked={xItem.checked}
                                        onChange={e=>{selectCounty(e, xItem);}}
                                    />
                                    {xItem.areaName}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderCity = ()=>{
        let list = Object.values(cityObj);
        return (
            <ul className={styles.cityList}>
                {list.map((city, index)=>{
                    return (
                        <li key={city.cityId}>
                            <Checkbox style={{marginRight: '5px'}} 
                                disabled={city.availableChildCnt==0}
                                checked={city.checked == 1}
                                indeterminate={city.checked == 2}
                                onChange={e=>{selectCity(e, city);}}
                            />
                            <div onClick={(e)=>{onCityClick(e, city.cityId);}}>{city.cityName}<CaretDownOutlined style={{marginLeft: '3px', marginRight: '-10px'}} /></div>
                        </li>
                    );
                })}
            </ul>
        );
    };

    const disabledDate = (date)=>{
        return date < moment().startOf('day');
    };
    const _disabledTime = (dates)=>{
         
        let hours = moment().hours();
        let minutes = moment().minutes();
        let seconds = moment().seconds();

        const range = (start, end) => {
            const result = [];
            for (let i = start; i <= end; i++) {
                result.push(i);
            }
            return result;
        };

        if(!dates){
            return {
                disabledHours: () => range(0, hours-1),
                disabledMinutes: () => range(0, minutes),
                disabledSeconds: () => range(0, seconds),
            };
        }

        let selectDate = dates.format('YYYY/MM/DD');
        let selectDateTime = new Date(selectDate).getTime();
        let today = moment().format('YYYY/MM/DD');
        let todayTime = new Date(today).getTime();
        let selectHours = dates.hours();  
        
        if(selectDateTime > todayTime){
            return null;
        }else if (selectHours > hours){
            return {
                disabledHours: () => range(0, hours-1),
            };
        }else{
            return {
                disabledHours: () => range(0, hours-1),
                disabledMinutes: () => range(0, minutes),
                disabledSeconds: () => range(0, seconds),
            };
        }
        
    };

    return (
        <Modal title={`${logId ? '编辑' : '新建'}运费调控 - ${props.data.templateName}`} visible={true} centered maskClosable={false} width={800} destroyOnClose={true}
            onOk={onOk}
            onCancel={props.onCancel}
        >
            <div className={styles.formBox}>
                <div className={styles.item}>
                    <div className={styles.label}><span>*</span>调控原因：</div>
                    <div className={styles.info}>
                        <Select value={reason} style={{width: '300px'}} labelInValue={true} onChange={reasonChange} placeholder="请选择调控原因">
                            {reasonOptions.map(v=>{
                                return (
                                    <Option key={v.code} value={v.code}>{v.value}</Option>
                                );
                            })}
                        </Select>
                    </div>
                </div>
                <div className={styles.item} style={{alignItems: 'flex-start'}}>
                    <div className={styles.label}><span>*</span>调控地域：</div>
                    <div className={styles.info}>
                        {renderCity()}
                        {renderCounty()}
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}><span>*</span>调控时间：</div>
                    <div className={styles.info}>
                        <RangePicker disabledDate={disabledDate} disabledTime={_disabledTime} defaultValue={[]} value={makeControlTime(startTime, endTime)} showTime={{format: 'HH:mm'}} format={'YYYY-MM-DD HH:mm'} onChange={onControlTimeChange}/>
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}><span>*</span>调控方式：</div>
                    <div className={styles.info}>
                        <div className={styles.controlMethod}>
                            <Radio.Group onChange={onControlMethodChange} value={controlMethod}>
                                <Radio key="PERCENT" value="PERCENT">百分比例</Radio>
                                <Radio key="AMOUNT" value="AMOUNT">固定金额</Radio>
                            </Radio.Group>
                        </div>
                        {controlMethod == 'PERCENT' ? (
                            <div className={styles.percent}>
                                <div>上浮<Input className={styles.txt} onChange={onPercentChange} value={percent} />%</div>
                                <p>调控后运费=原配送运费*(1+上浮比例），上浮不可超过200%</p>
                            </div>
                        ) : null}
                        {controlMethod == 'AMOUNT' ? (
                            <div className={styles.fixedVal}>
                                <div>增加<Input className={styles.txt} onChange={onFixedValChange} value={fixedVal} />元</div>
                                <p>调控后运费=原配送运费+固定金额；增加金额不能超过100元</p>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

UserControlFee.propTypes = {
    onCancel: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    logId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default UserControlFee;